import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  gap: 20px;

  > div {
    width: 100%;
  }

  h1 {
    line-height: 23px;
  }

  span {
    line-height: 21px;
  }

  ${mobile`
    flex-direction: column;
    gap: 0;
  `}
`;

const BuilderTwoColumnGrid = (props) => {
  return (
    <Container data-builder-component-type="storytelling_two_column_grid">
      {props.columns.map((column, index) => (
        <BuilderBlocks
          key={index}
          parentElementId={props.builderBlock && props.builderBlock.id}
          dataPath={`component.options.columns.${index}.content`}
          child
          blocks={column.content || column}
        />
      ))}
    </Container>
  );
};

BuilderTwoColumnGrid.propTypes = {
  builderBlock: PropTypes.any,
  columns: PropTypes.array,
};

export default BuilderTwoColumnGrid;
